<template>
	<div class="i-nav">
		<div class="header">
			<div class="logo">
				<img src="../../assets/img/logo.png" alt="" srcset="">
			</div>
			<el-input placeholder="搜索院校、专业、资讯" v-model="key">
				<template slot="append">搜索</template>
			</el-input>
			<div class="rightLoginInfo">
				<div style="margin-right: 20px;" class="point" @click="changeProvinceDialog">
					{{ userInfo.enrollProvinceId }}<i class="el-icon-arrow-down"></i>
				</div>
				<div v-if="isLoginFlag" class="point" @click="changeScore">
					{{ userInfo.selectSubject }}<i class="el-icon-edit"></i>
				</div>
				<img v-if="userInfo.memberCode" style="width: 20px;margin: 0 20px;" class="point" src="@/assets/img/vip-fill (1).png" alt="">
				<img v-else style="width: 20px;margin: 0 20px;" @click="openVip" class="point" src="@/assets/img/vip-fill.png" alt="">
				<el-button class="i-button" @click="loginSub" icon="el-icon-user-solid" v-if="!isLoginFlag">登录/注册</el-button>
				<el-button class="i-button" @click="logout" icon="el-icon-user-solid" v-if="isLoginFlag">退出</el-button>
			</div>
		</div>
		<div class="i-menu">
			<el-menu active-text-color="#fff" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
				text-color="#fff" background-color="#5A0096">
				<el-menu-item index="/index" @click="handleSelect('/index')">首页</el-menu-item>
				<el-menu-item index="/college" @click="handleSelect('/college')">大学查询</el-menu-item>
				<el-menu-item index="/major" @click="handleSelect('/major')">专业查询</el-menu-item>
				<el-menu-item index="/batch" @click="handleSelect('/batch')">批次查询</el-menu-item>
				<el-menu-item index="/provincerank" @click="handleSelect('/provincerank')">位次查询</el-menu-item>
				<el-menu-item index="/collegerank" @click="handleSelect('/collegerank')">大学排行</el-menu-item>
				<el-menu-item index="/subject" @click="handleSelect('/subject')">新高考选科</el-menu-item>
				<el-menu-item index="/fillIn" @click="handleSelect('/fillIn')">智能志愿填报</el-menu-item>
				<el-menu-item index="/user" @click="handleSelect('/user')" v-if="isLoginFlag">个人中心</el-menu-item>
			</el-menu>
		</div>
		<Login ref="loginDialog"></Login>
		<update-info v-if="$store.state.user.updateInfoFlag"></update-info>
		<update-score v-if="$store.state.user.updateScoreFlag"></update-score>
		<el-dialog title="选择高考省份" :visible.sync="dialogVisible" width="500px">
			<div style="display: flex;justify-content: space-around;">
				<el-button v-for="(item, index) in provinceList" @click="changeProvince(item)" :key="index"
					:type="userInfo.enrollProvinceId == item.dictLabel ? 'primary' : ''" round>{{ item.dictLabel
					}}</el-button>
			</div>
		</el-dialog>
		<openVip ref="openVip"></openVip>
	</div>
</template>

<script>
import Login from "../login"
import UpdateInfo from "../updateInfo"
import updateScore from "../updateScore"
import openVip from "../openVip"
import { getSupportProvince, updateStudent,  currentStudent } from "@/api/login";
export default {
	name: "nav-menu",
	components: {
		Login, UpdateInfo, updateScore,openVip
	},
	data() {
		return {
			activeIndex: '/index',
			key: "",
			dialogVisible: false,
			dialogVisibleVip: false,
			userInfo: {},
			provinceList: []
		}
	},
	computed: {
		isLoginFlag() {
			return this.$store.state.user.isLoginFlag
		},
		stateFromVuex() {
			return this.$store.state.user.studentData;
		}
	},
	watch: {
		$route(to, from){
			this.activeIndex =  to.path
            console.log('路由变化了')

            console.log('当前页面路由：' + to.path);

            console.log('上一个路由：' + from);

        },
		isLoginFlag: {
			async handler(newVal, oldVal) {
				if (this.isLoginFlag) {
					let user = await currentStudent();
					if (user && user.code == 200) {
						this.userInfo = user.data
					}

				}else{
					this.userInfo={}
				}
			},
			deep: true
		},
		stateFromVuex: {
			async handler(newVal, oldVal) {
				let user = await currentStudent();
				if (user && user.code == 200) {
					this.userInfo = user.data
				}
			},
			deep: true
		}
	},
	async created() {
		this.isLoginFlag = this.$store.state.user.isLoginFlag
		if (this.isLoginFlag) {
			let user = await currentStudent();
			if (user && user.code == 200) {
				this.userInfo = user.data
			}
		}else{
			this.userInfo={}
		}
		this.activeIndex = this.$route.path
		this.getCanChooseProvince()
	},
	methods: {
		openVip() {
			if (this.isLoginFlag) {
				this.$refs.openVip.init()
			} else {
				this.loginSub()
			}
		},
		
		changeProvince(item) {
			this.userInfo.enrollProvinceId = item.dictLabel
			updateStudent(this.userInfo).then(res => {
				if (res && res.code == 200) {
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.dialogVisible = false
					this.$store.commit("UPDATE_STUDENT", this.userInfo)
				}
			})
		},
		changeProvinceDialog() {
			this.dialogVisible = true
		},
		changeScore() {
			this.$store.commit("UPDATE_UPDATESCOREFLAG", true);
		},
		async getCanChooseProvince() {
			let res = await getSupportProvince();
			this.provinceList = res.data
		},
		handleSelect(path) {
			if (!this.isLoginFlag && path == '/subject') {
				this.$store.commit("UPDATE_LOGINSHOWFLAG", true)
			} if (!this.isLoginFlag && path == '/fillIn') {
				this.$store.commit("UPDATE_LOGINSHOWFLAG", true)
			} else {
				this.$router.push(path).catch(err => { });
			}
		},
		loginSub() {
			this.$store.commit("UPDATE_LOGINSHOWFLAG", true)
		},
		logout() {
			this.$store.commit("UPDATE_ISLOGINFLAG", false);
			this.$store.commit("UPDATE_TOKEN", '');
			this.$store.commit("UPDATE_STUDENT", {});
			this.isLoginFlag = this.$store.state.user.isLoginFlag
			if (this.$route.path != '/index') {
				this.$router.push("/index");
			}

		}
	}
}
</script>

<style lang="less">
.i-nav {

	.rightLoginInfo {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #515a6e;
	}

	.header {
		position: relative;
		max-width: 1200px;
		min-width: 1000px;
		margin: 0 auto;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-around;

		.logo {
			width: 170px;
			height: 45px;
			min-width: 200px;
			margin-right: 50px;

			img {
				height: 45px;
			}
		}

		.addr {
			border: 1px solid #eee;
			padding: 2px 4px;
			margin-right: 50px;
		}

		.el-input {
			width: 380px;
		}

		.el-input-group__append {
			background-image: linear-gradient(to right, #5A0096, #3D1EE1);
			color: #fff;
		}

		.i-button {
			border-radius: 20px;
			border-color: #3A21E5;
		}



		// .el-menu--horizontal {
		//     border: none !important;
		// }

	}

	.el-menu.el-menu--horizontal {
		border: none !important;
	}

	.i-menu {
		background-color: #5A0096;
		display: flex;
		align-items: center;
		height: 48px;

		ul {
			width: 1200px;
			min-width: 1200px;
			margin: 0 auto;
			height: 48px;

			.el-dropdown-menu__item,
			.el-menu-item {
				font-size: 18px;
				margin-left: 10px;
				height: 48px;
				line-height: 48px;
			}

			.is-active {
				border-bottom-color: #490078 !important;
				background-color: #490078 !important;
			}
		}

		.kui-menu-right {
			cursor: pointer;
			float: left;
			color: #fff;
			padding: 0;
		}

		.kui-menu-right a {
			padding: 0 20px;
			font-size: 14px;
			color: #fff;
			font-weight: 500;
			display: block;
		}

	}
}
</style>